import React from 'react';
import ResponsiveWrapper from '../components/ResponsiveWrapper';
import SystemGuide from './index';
import MobileSystemGuide from './MobileSystemGuide';

const ResponsiveSystemGuide = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileSystemGuide />}
      desktop={<SystemGuide />}
    />
  );
};

export default ResponsiveSystemGuide;